import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {NavigationService} from '../../services/navigation/navigation.service';
import {SelectableNavigationItem} from '../../model/selectable-navigation-item';

@Component({
  selector: 'app-navigable-button',
  templateUrl: './navigable-button.component.html',
  styleUrls: ['./navigable-button.component.less']
})
export class NavigableButtonComponent extends SelectableNavigationItem implements OnInit, OnDestroy {
  @Output()
  emitOnEnterPressed = new EventEmitter<Object>();
  @Output()
  emitOnBack = new EventEmitter<Object>();
  @Input() shadow: boolean;
  @Input() widthPercentage: string;

  constructor(private navigationService: NavigationService,
              private changeDetection: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.navigationService.registerNavigation(this, this.ownerComponent);
  }

  onEnter(): void {
    this.emitOnEnterPressed.emit({
      value: true
    });
  }

  onBack(): void {
    this.emitOnBack.emit({
      value: true
    });
  }

  activate(active: boolean): void {
    this.active = active;
    this.changeDetection.detectChanges();
  }

  ngOnDestroy(): void {
    this.changeDetection.detach();
  }
}
